import { motion } from "framer-motion";
import { useState } from "react";
import { useLocation } from 'react-router-dom';

const formUrls = {
  zakah: 'https://www.zeffy.com/embed/donation-form/tampa-zakah-fundzakah-funds-only',
  sadaqa: 'https://www.zeffy.com/embed/donation-form/tampa-zakah-fundsadaqa-funds-only',
};

const Donate = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  // Determine which form to show based on the route
  let formType = 'zakah';
  if (location.pathname.includes('sadaqa')) formType = 'sadaqa';

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <motion.div
      style={{
        minHeight: '100vh',
        width: '100vw',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: 0,
        margin: 0,
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h2 style={{
        color: '#2c3e50',
        fontWeight: 'bold',
        fontSize: '2rem',
        margin: '2rem 0 1rem 0',
        textAlign: 'center',
        width: '100%',
      }}>
        {formType === 'zakah' ? 'Pay your Zakah' : 'Donate to Sadaqa Funds'}
      </h2>
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '900px',
          height: '80vh',
          minHeight: '400px',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          background: '#fff',
          border: '1px solid #e5e7eb',
          margin: '0 auto',
        }}
      >
        {isLoading && (
          <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 10,
          }}>
            <div style={{
              border: '4px solid #e5e7eb',
              borderTop: '4px solid #3498db',
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              animation: 'spin 1s linear infinite',
            }} />
            <p style={{
              marginTop: '1rem',
              fontSize: '1.1rem',
              fontWeight: 600,
              color: '#2c3e50',
              fontFamily: 'sans-serif',
            }}>Please Have Sabr, almost there!</p>
          </div>
        )}
        <iframe
          title={`Donation form powered by Zeffy - ${formType}`}
          style={{
            border: 0,
            width: '100%',
            height: '100%',
            minHeight: '400px',
          }}
          src={formUrls[formType]}
          allowTransparency={true}
          onLoad={handleIframeLoad}
        />
      </div>
      <style>
        {`
          @media (max-width: 600px) {
            h2 {
              font-size: 1.3rem !important;
              margin: 1rem 0 0.5rem 0 !important;
            }
            div[style*="maxWidth: '900px'"] {
              min-height: 300px !important;
              height: 65vh !important;
              border-radius: 8px !important;
            }
          }
          @keyframes spin {
            0% { transform: rotate(0deg);}
            100% { transform: rotate(360deg);}
          }
        `}
      </style>
    </motion.div>
  );
};

export default Donate; 